import instance from "../axios";

export const getAll = async (filters = {}) => {
  try {
    const response = await instance.get(`products`, { params: filters });
    return response.data;
  } catch (e) {
    console.log(e)
  }
};

export const getAllCategories = async () => {
  const response = await instance.get(`categories`)
  return response.data;
}

export const getForPO = async () => {
  const response = await instance.get(`products/getForPO`);
  return response.data;
};

export const insert = async (data) => {
  const response = await instance.post(`products`, data);
  return response;
};

export const update = async (data) => {
  const response = await instance.put(`products`, data);
  return response;
};

export const remove = async (id) => {
  const response = await instance.delete(`products/` + id);
  return response;
};

export const transfer = async (data) => {
  const response = await instance.post(`products/transfer`, data);
  return response;
};

export const passwordValidation = async (data) => {
  const response = await instance.post(`products/password`, data);
  return response;
};

export const getProductDetails = async (id) => {
  const response = await instance.get(`products/details/` + id);
  return response.data;
} 
